export enum RoutePaths {
  Login = '/login',
  EventDetail = '/events-detail',
  SentSms = '/sent-sms',

  // Audit system routes
  AuditDashboard = '/audit',
  AuditPoint = '/audit/point',
  AuditContent = '/audit/content',
  AuditCourier = '/audit/courier',
  AuditContact = '/audit/contact',
}
